const regulatoryPlatform = {
  path: "/regulatoryPlatform", // 主体
  name: "regulatoryPlatform",
  redirect: "/superviseIndex",
  component: () => import("../views/regulatoryPlatform/main"),
  children: [
    {
      path: "/healthDescribe",
      name: "healthDescribe",
      meta: {
        title: "健康资讯"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/healthDescribe/Index.vue")
    },
    {
      path: "/electronicRecord",
      name: "electronicRecord",
      mate: {
        title: "电子病历"
      },
      component: () =>
          import("../views/regulatoryPlatform/treatmentConvalesce/electronicRecord")
    },
    {
      path: "/medicalInstructed",
      name: "medicalInstructed",
      mate: {
        title: "医护嘱执行"
      },
      component: () =>
          import("../views/regulatoryPlatform/treatmentConvalesce/medicalInstructed"),
      children: [
        {
          path: "/medicalAdviceManagement",
          name: "medicalAdviceManagement",
          mate: {
            title: "医嘱管理"
          },
          component: () =>
              import("../views/regulatoryPlatform/treatmentConvalesce/medicalAdviceManagement")
        },
        {
          path: "/medicalAdviceExecute",
          name: "medicalAdviceExecute",
          mate: {
            title: "医嘱执行"
          },
          component: () =>
              import("../views/regulatoryPlatform/treatmentConvalesce/medicalAdviceExecute")
        }
      ]
    },
    {
      path: "/healthRecord",
      name: "healthRecord",
      meta: {
        title: "健康档案"
      },
      component: () =>
          import("../views/regulatoryPlatform/treatmentConvalesce/healthRecord.vue")
    },
    {
      path: "/healthWarning",
      name: "healthWarning",
      meta: {
        title: "健康预警"
      },
      component: () =>
          import("../views/regulatoryPlatform/healthWarning/index.vue")
    },
    {
      path: "/archivesOfTheElderly",
      name: "archivesOfTheElderly",
      meta: {
        title: "老人档案"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/archivesOfTheElderly.vue")
    },
    {
      path: "/pendingApplication",
      name: "pendingApplication",
      meta: {
        title: "待提交"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newApply/pendingApplication.vue")
    },
    {
      path: "/applicationing",
      name: "applicationing",
      meta: {
        title: "街道审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newApply/applicationing.vue")
    },
    {
      path: "/pendingApproval",
      name: "pendingApproval",
      meta: {
        title: "区级审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newApply/pendingApproval.vue")
    },
    {
      path: "/immigrationApplication",
      name: "immigrationApplication",
      meta: {
        title: "迁入申请"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/immigration/immigrationApplication.vue")
    },
    {
      path: "/moveOutRecord",
      name: "moveOutRecord",
      meta: {
        title: "迁出申请"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/moveOutRecord.vue")
    },
    {
      path: "/immigrationApply",
      name: "immigrationApply",
      meta: {
        title: "申请中"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/immigration/immigrationApply.vue")
    },
    {
      path: "/immigrationExamine",
      name: "immigrationExamine",
      meta: {
        title: "迁入待审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/immigration/immigrationExamine.vue")
    },
    {
      path: "/immigrationAdopt",
      name: "immigrationAdopt",
      meta: {
        title: "迁入申请通过"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newImmigration/immigrationAdopt.vue")
    },
    {
      path: "/immigrationAdoptNo",
      name: "immigrationAdoptNo",
      meta: {
        title: "迁入申请不通过"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newImmigration/immigrationAdoptNo.vue")
    },
    {
      path: "/newAdopt",
      name: "newAdopt",
      meta: {
        title: "新申请通过"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newImmigration/newAdopt.vue")
    },
    {
      path: "/newAdoptNo",
      name: "newAdoptNo",
      meta: {
        title: "新申请不通过"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/newImmigration/newAdoptNo.vue")
    },
    {
      path: "/settlementAnalysis",
      name: "settlementAnalysis",
      meta: {
        title: "结算分析"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/analysis/settlementAnalysis.vue")
    },
    {
      path: "/monthAll",
      name: "monthAll",
      meta: {
        title: "本月全部"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthAll.vue")
    },
    {
      path: "/monthImmigration",
      name: "monthImmigration",
      meta: {
        title: "本月迁入"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthImmigration.vue")
    },
    {
      path: "/monthMove",
      name: "monthMove",
      meta: {
        title: "本月迁出"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthMove.vue")
    },
    {
      path: "/releaseRecord",
      name: "releaseRecord",
      meta: {
        title: "发放记录"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/release/releaseRecord.vue")
    },
    {
      path: "/statisticalAnalysisElderly",
      name: "statisticalAnalysisElderly",
      meta: {
        title: "老人统计分析"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/statisticalAnalysisElderly.vue")
    },
    {
      path: "/statisticsElderlyOfAllAges",
      name: "statisticsElderlyOfAllAges",
      meta: {
        title: "各年龄段老人统计"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/statisticsElderlyOfAllAges.vue")
    },
    {
      path: "/statisticsOfSubsidiesIssuedByStreets",
      name: "statisticsOfSubsidiesIssuedByStreets",
      meta: {
        title: "各街道发放补贴统计"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/statisticsOfSubsidiesIssuedByStreets.vue")
    },
    {
      path: "/halfMonthlyDistributionStatistics",
      name: "halfMonthlyDistributionStatistics",
      meta: {
        title: "半月发放统计"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/halfMonthlyDistributionStatistics.vue")
    },
    {
      path: "/statisticsAllowanceAllAgeGroups",
      name: "statisticsAllowanceAllAgeGroups",
      meta: {
        title: "各年龄段总津贴统计"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/statisticsAllowanceAllAgeGroups.vue")
    },
    {
      path: "/monthGrade",
      name: "monthGrade",
      meta: {
        title: "本月升级"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthGrade.vue")
    },
    {
      path: "/centenarian",
      name: "centenarian",
      meta: {
        title: "百岁老人"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/centenarian.vue")
    },
    {
      path: "/endMen",
      name: "endMen",
      meta: {
        title: "注销老人"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/endMen.vue")
    },
    {
      path: "/monthCancle",
      name: "monthCancle",
      meta: {
        title: "本月注销"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthCancle.vue")
    },
    {
      path: "/monthAdd",
      name: "monthAdd",
      meta: {
        title: "本月新增"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/month/monthAdd.vue")
    },
    {
      path: "/distributionSettings",
      name: "distributionSettings",
      meta: {
        title: "补贴发放设置"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/dataDictionary/distributionSettings.vue")
    },
    {
      path: "/financialAllocation",
      name: "financialAllocation",
      meta: {
        title: "财政分摊比例"
      },
      component: () =>
          import("../views/regulatoryPlatform/managementForTheAged/dataDictionary/financialAllocation.vue")
    },
    {
      path: "/slowDiseaseManage",
      name: "slowDiseaseManage",
      meta: {
        title: "慢病管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/medicalCareSystem/slowDiseaseManage/index.vue")
    },
    {
      path: "/drugsManagements",
      name: "drugsManagements",
      meta: {
        title: "药品管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/medicalCareSystem/dataDictionary/drugsManagements.vue")
    },
    {
      path: "/nursingLevel",
      name: "nursingLevel",
      meta: {
        title: "护理级别"
      },
      component: () =>
          import("../views/regulatoryPlatform/medicalCareSystem/nursingLevel/nursingLevel.vue")
    },
    {
      path: "/HospitalInformation",
      name: "HospitalInformation",
      meta: {
        title: "医院信息"
      },
      component: () =>
          import("../views/regulatoryPlatform/hospitalManage/HospitalInformation.vue")
    },
    {
      path: "/officeManage",
      name: "officeManage",
      meta: {
        title: "科室管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/hospitalManage/officeManage.vue")
    },
    {
      path: "/doctorManage",
      name: "doctorManage",
      meta: {
        title: "医生管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/hospitalManage/doctorManage.vue")
    },
    {
      path: "/deviceManagement",
      name: "deviceManagement",
      meta: {
        title: "新增设备"
      },
      component: () =>
          import("../views/regulatoryPlatform/intelligentRegulation/deviceManagement.vue")
    },
    {
      path: "/patrolManagement",
      name: "patrolManagement",
      meta: {
        title: "巡检管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/intelligentRegulation/patrolManagement.vue")
    },
    {
      path: "/complaintManage",
      name: "complaintManage",
      meta: {
        title: "投诉管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/complaintManage/index.vue")
    },
    {
      path: "/inspectEvent",
      name: "inspectEvent",
      meta: {
        title: "巡检事件"
      },
      component: () =>
        import("../views/regulatoryPlatform/inspectEvent/index.vue")
    },
    {
      path: "/fenceAlarm",
      name: "fenceAlarm",
      meta: {
        title: "围栏报警"
      },
      component: () =>
        import("../views/regulatoryPlatform/fenceAlarm/fenceAlarm.vue")
    },
    {
      path: "/bedMonitoring",
      name: "bedMonitoring",
      meta: {
        title: "卧床监测"
      },
      component: () =>
        import("../views/regulatoryPlatform/bedMonitoring/bedMonitoring.vue")
    },
    {
      path: "/videoSurveillance",
      name: "videoSurveillance",
      meta: {
        title: "视频监控"
      },
      component: () =>
        import("../views/regulatoryPlatform/videoSurveillance/videoSurveillance.vue")
    },
    {
      path: "/homeSecurity",
      name: "homeSecurity",
      meta: {
        title: "居家安防"
      },
      component: () =>
        import("../views/regulatoryPlatform/homeSecurity/homeSecurity.vue")
    },
    {
      path: "/fireControlIndex",
      name: "fireControlIndex",
      meta: {
        title: "首页"
      },
      component: () =>
          import("../views/regulatoryPlatform/intelligentRegulation/fireControlIndex.vue")
    },
    {
      path: "/hardwareMaintain",
      name: "hardwareMaintain",
      meta: {
        title: "硬件商品信息维护"
      },
      component: () =>
          import("../views/regulatoryPlatform/deviceManager/hardwareMaintain/index.vue")
    },
    {
      path: "/modelManage",
      name: "modelManage",
      meta: {
        title: "设备型号管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/deviceManager/modelManage/index.vue")
    },
    {
      path: "/TypesManage",
      name: "TypesManage",
      meta: {
        title: "设备类型维护"
      },
      component: () =>
          import("../views/regulatoryPlatform/deviceManager/TypesManage/index.vue")
    },
    {
      path: '/deviceUpload',
      name: 'deviceUpload',
      meta: {
        title: '设备上传数据'
      },
      component: () => import ('../views/regulatoryPlatform/device/deviceUpload.vue'),
    },
    {
      path: '/removalManagement',
      name: 'removalManagement',
      meta: {
        title: '布撤防管理'
      },
      component: () => import ('../views/regulatoryPlatform/device/removalManagement.vue'),
    },
     {
      path: "/intellSnatch",
      name: "intellSnatch",
      meta: {
        title: "智能网联"
      },
      component: () =>
          import("../views/regulatoryPlatform/middleInternet/intellSnatch.vue")
    },
    {
      path: "/inventorManage",
      name: "inventorManage",
      meta: {
        title: "库存管理"
      },
      component: () =>
          import("../views/regulatoryPlatform/middleInternet/inventorManage.vue")
    },
    {
      path: '/device',
      name: 'device',
      meta: {
        title: '设备管理'
      },
      component: () => import ('../views/regulatoryPlatform/newDevice/newDevice.vue'),
    },
    {
      path: '/alarmRecord',
      name: 'device',
      meta: {
        title: '人体感知'
      },
      component: () => import ('../views/regulatoryPlatform/newDevice/alarmRecord.vue'),
    },
    {
      path: '/jhlAlarm',
      name: 'device',
      meta: {
        title: '精华隆人体感知'
      },
      component: () => import ('../views/regulatoryPlatform/newDevice/jhlAlarm.vue'),
    },
    {
      path: '/tjlhAlarm',
      name: 'tjlhAlarm',
      meta: {
        title: '淘景立画'
      },
      component: () => import ('../views/regulatoryPlatform/newDevice/tjlhAlarm.vue'),
    },
    {
      path: '/EquipmentList',
      name: 'EquipmentList',
      meta: {
        title: '设备清单'
      },
      component: () => import ('../views/regulatoryPlatform/device/EquipmentList.vue'),
    },
    {
      path: '/fallAlarm',
      name: 'fallAlarm',
      meta: {
        title: '跌倒报警'
      },
      component: () => import ('../views/regulatoryPlatform/safetyMonitoring/fallAlarm.vue'),
    },
    {
      path: '/positioningManagement',
      name: 'positioningManagement',
      meta: {
        title: '定位管理'
      },
      component: () => import ('../views/regulatoryPlatform/safetyMonitoring/positioningManagement.vue'),
    },
    {
      path: '/filleye',
      name: 'filleye',
      meta: {
        title: 'SOS报警'
      },
      component: () => import ('../views/regulatoryPlatform/safetyMonitoring/filleye.vue'),
    },
    {
      path: '/securityAlarm',
      name: 'securityAlarm',
      meta: {
        title: '安防告警'
      },
      component: () => import ('../views/regulatoryPlatform/safetyMonitoring/securityAlarm.vue'),
    },
    {
      path: "/superviseMap",
      name: "superviseMap",
      meta: {
        title: "监管地图"
      },
      component: () =>
        import("../views/regulatoryPlatform/intelligentSupervisionSystem/wisdomRegulation/regulationMap/index.vue")
    },
    // {
    //   path: "/intelligentMonitoring",
    //   name: "intelligentMonitoring",
    //   meta: {
    //     title: "智能监控"
    //   },
    //   component: () =>
    //     import("../views/regulatoryPlatform/intelligentSupervisionSystem/wisdomRegulation/intelligentMonitoring/index.vue")
    // },
    {
      path: "/intelligentMonitoring",
      name: "intelligentMonitoring",
      meta: {
        title: "智能监控"
      },
      component: () =>
        import("../views/regulatoryPlatform/intelligentSupervisionSystem/wisdomRegulation/videoMonitoring/index.vue")
    },
    {
      path: "/safevisit",
      name: "safevisit",
      meta: {
        title: "消防安全"
      },
      component: () =>
        import("../views/regulatoryPlatform/intelligentSupervisionSystem/fireSafety/safevisit/index.vue")
    },
    {
      path: "/enterMessage",
      name: "enterMessage",
      meta: {
        title: "繁昌信息调查表"
      },
      component: () =>
        import("../views/regulatoryPlatform/householdManagement/enterMessage.vue")
    },
    {
      path: "/jiangMessage",
      name: "jiangMessage",
      meta: {
        title: "江西信息调查表"
      },
      component: () =>
        import("../views/regulatoryPlatform/householdManage/jiangMessage.vue")
    },
    {
      path: "/elderlyAudit",
      name: "elderlyAudit",
      meta: {
        title: "老人审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/elderlyAudit/elderlyAudit.vue")
    },
    {
      path: "/homeData",
      name: "homeData",
      meta: {
        title: "居家工单"
      },
      component: () =>
          import("../views/regulatoryPlatform/superviseData/homeData.vue")
    },
    {
      path: "/peopleData",
      name: "peopleData",
      meta: {
        title: "服务人员"
      },
      component: () =>
          import("../views/regulatoryPlatform/superviseData/peopleData.vue")
    },
    {
      path: "/objectData",
      name: "objectData",
      meta: {
        title: "服务对象"
      },
      component: () =>
          import("../views/regulatoryPlatform/superviseData/objectData.vue")
    },
    {
      path: "/statisticsExport",
      name: "statisticsExport",
      meta: {
        title: "数据统计导出"
      },
      component: () =>
          import("../views/regulatoryPlatform/statisticsExport.vue")
    },
    {
      path: "/serviceAudit",
      name: "serviceAudit",
      meta: {
        title: "服务审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/serviceAudit.vue")
    },
    {
      path: "/stopServiceAudit",
      name: "stopServiceAudit",
      meta: {
        title: "停止服务审核"
      },
      component: () =>
          import("../views/regulatoryPlatform/stopServiceAudit.vue")
    } ,
    {
      path: "/serviceStatus",
      name: "serviceStatus",
      meta: {
        title: "历史服务状态"
      },
      component: () =>
          import("../views/regulatoryPlatform/serviceStatus.vue")
    },
    {
      path: "/superviseIndex",
      name: "superviseIndex",
      meta: {
        title: "首页"
      },
      component: () =>
          import("../views/regulatoryPlatform/superviseIndex.vue")
    }
  ]
}
export default regulatoryPlatform
